import { useClerk, useUser } from '@clerk/nextjs';
import Button from './ui/Button';
import Loading from './ui/Loading';
import { useRouter } from 'next/router';
import { useState } from 'react';

import Avatar from './Avatar';
import Menu from './Menu';

const settingsOptions = [
  { key: 'roadmaps', value: 'Roadmaps' },
  { key: 'logout', value: 'Logout' },
];

export default ({ logoSize = 'md' }) => {
  const { isLoaded, isSignedIn, user } = useUser();
  const { signOut } = useClerk();
  const [signingOut, setSigningOut] = useState(false);
  const router = useRouter();

  const handleSignIn = () => router.push('/auth/signin');

  const handleSettingClick = selectedOption => {
    if (selectedOption === 'roadmaps') {
      router.push('/roadmaps');
    } else if (selectedOption === 'logout') {
      setSigningOut(true);
      signOut({ redirectUrl: '/' });
    }
  };

  if (!isLoaded || signingOut) {
    return (
      <div className="flex items-center justify-end w-16 h-16 mx-1 text-sm whitespace-no-wrap">
        <Loading />
      </div>
    );
  }

  return isSignedIn ? (
    <Menu
      icon={<Avatar user={{ image: user.imageUrl }} size={logoSize} />}
      options={settingsOptions}
      onSelect={handleSettingClick}
    />
  ) : (
    <Button className="btn btn-small" onClick={handleSignIn}>
      Sign In
    </Button>
  );
};
